import React, { createContext, useContext, useState, useEffect } from "react";
import { t } from "../i18n/translations";

const STORAGE_KEY = "emergencyqr_lang";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (key) => key,
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      console.warn("Could not persist language", e);
    }
  }, [lang]);

  const setLang = (newLang) => {
    if (newLang === "en" || newLang === "hi") setLangState(newLang);
  };

  const tWithLang = (key) => t(key, lang);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: tWithLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
